import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    taskId: Number,
    processReference: String,
  }

  connect() {
    window.dispatchEvent(
      new CustomEvent("task-actioned", {
        detail: {
          taskId: this.taskIdValue,
          processReference: this.processReferenceValue,
        },
      }),
    )

    // Remove the element once the event has fired to avoid DOM buildup
    this.element.remove()
  }
}
